import Image from "next/image";
import axios from "axios";
import { GetServerSidePropsContext } from "next";
import MarketingEnrollNowForm from "@/components/Masterclass/MarketingPaidForm";
import React from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import Link from "next/link";

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const id = "clw957zzy05ngpcbinwpsxwv7";
  const host = context.req?.headers.host;
  const protocol = context.req?.headers["x-forwarded-proto"] || "http";
  const fullDomain = `${protocol}://${host}`;

  try {
    const { data } = await axios.get(
      `${process.env.NEXT_PUBLIC_BASE_API}masterclasses/${id}`,
      {
        headers: {
          "Accept-Encoding": "gzip",
        },
      }
    );

    return {
      props: {
        id: id,
        masterclass: data.data,
        fullDomain: fullDomain,
      },
    };
  } catch (err) {
    return {
      props: {
        masterclass: null,
        id: "",
        fullDomain: "https://www.tradewiseapp.com/",
      },
    };
  }
}

function HOT({
  id,
  masterclass,
  fullDomain,
}: {
  id: string;
  masterclass: any;
  fullDomain: string;
}) {
  const [isEnrollNowFormOpen, setIsEnrollNowFormOpen] = React.useState(false);
  const handleLeadModalOpen = () => {
    setIsEnrollNowFormOpen(true);
  };
  const router = useRouter();
  const source = router.query.source;
  const leadComment = router.query.comment;
  const backComment = source === "google" ? "paidMasterClass" : "paidBootcamp";

  if (typeof window !== "undefined" && !masterclass) {
    window.location.href = "https://www.tradewiseapp.com/masterclasses";
  }
  const slots = masterclass?.slots;
  const activeSlot = slots?.find((slot: any) => {
    return slot.active;
  });
  const token =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjQ5LCJpYXQiOjE3NDQ0NDAyMzV9.grKK26hq373iIppM-D6lt7RbEZOPw4wUcrW-F5Bj0Mo";
  const redirectURL = `${fullDomain}/${id}/redirect/products/thanks-paid`;
  const bannerClass =
    "bg-[linear-gradient(90deg,rgba(18,210,18,0.2)_0%,rgba(24,221,24,0.2)_9.33%,rgba(60,255,60,0)_69.8%,rgba(60,255,60,0)_73.29%,rgba(30,227,30,0)_79.92%,rgba(58,251,58,0)_83.56%)]";
  const isTaboola = source === "Taboola";
  return (
    <>
      <Head>
        <title>Swing Trading Kit | Tradewise</title>
        <meta
          name="description"
          content="Get the Swing Trading Kit with 80% Accurate Backtested Swing Trading Strategies"
        />
        <script
          dangerouslySetInnerHTML={{
            __html: `
             (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-5G6WR26B');
          `,
          }}
        />
      </Head>
      <main>
        {isTaboola && (
          <div className="bg-[#e1c1a5] text-black p-1 text-center top-0 right-0  items-center justify-center gap-2 hidden md:flex">
            <p className="text-xs text-center">
              © tradewise | Connect at: support@thefuture.university |{" "}
            </p>
            <Link href="/privacy-policy">
              <p className="text-xs text-center underline">Privacy Policy</p>
            </Link>
          </div>
        )}
        <noscript>
          <iframe
            src="https://www.googletagmanager.com/ns.html?id=GTM-5G6WR26B"
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
          ></iframe>
        </noscript>
        <MarketingEnrollNowForm
          masterClassData={masterclass}
          isOpen={isEnrollNowFormOpen}
          activePaidSlotInfo={activeSlot}
          closeModal={() => {
            setIsEnrollNowFormOpen(false);
          }}
          source={source}
          leadComment={leadComment}
          backComment={backComment}
          fullDomain={fullDomain}
          masterClassId={id}
          customToken={token}
          buttonClass=" !bg-green-500 p-4 rounded-md mt-5 text-xl md:text-xl !text-white  !animate-none !border-none"
          buttonText="Buy Now"
          customRedirect={redirectURL}
        />
        <div className="w-full min-h-screen bg-cover bg-no-repeat grid md:grid-cols-2 md:px-28 items-center justify-center px-6 bg-[#111] text-white">
          <Image
            src="/abhishek-options/logo-tradewise.png"
            alt="tradewise logo"
            height={150}
            width={150}
            className=" top-14 right-32 absolute max-md:hidden"
          />

          <div className="col-span-1 grid font-inter max-md:place-items-center max-md:text-center max-md:gap-1 md:gap-3">
            <div className="flex items-end sm:hidden">
              <Image
                src="/abhishek-options/logo-tradewise.png"
                alt="tradewise logo"
                height={100}
                width={100}
                className=" mt-4"
              />
            </div>

            <Image
              src="/marketing/swing_trading_kit/swing_trading_kit.png"
              alt="house of traders"
              height={150}
              width={150}
              className="w-[80vw] sm:hidden"
            />
            <h3 className="text-lg sm:text-2xl font-bold">
              Upgrade Your Trading Journey
            </h3>
            <h1 className="text-3xl sm:text-4xl md:text-6xl md:leading-[66px] font-semibold sm:leading-[50px] ">
              With 80% Accurate Swing Trading Strategies
            </h1>
            <p
              className={`p-2 rounded-md md:w-2/3 mt-3 min-w-full ${bannerClass}`}
            >
              Golden Crossover Strategy
            </p>
            <p
              className={`p-2 rounded-md md:w-2/3 mt-3 min-w-full ${bannerClass}`}
            >
              EMA 13 & 34 Crossover Strategy
            </p>
            <p
              className={`p-2 rounded-md md:w-2/3 mt-3 min-w-full ${bannerClass}`}
            >
              Step By Step Application Video
            </p>
            <p
              className={`p-2 rounded-md md:w-2/3 mt-3 min-w-full ${bannerClass}`}
            >
              24x7 Live Market Support
            </p>
            <button
              className=" bg-gradient-to-r from-green-500 via-green-600 to-green-700 p-4 rounded-md mt-5 text-xl md:text-2xl !text-white active:scale-105 w-full sm:w-[450px] border-none relative"
              onClick={handleLeadModalOpen}
            >
              <div className="absolute inset-0 bg-[linear-gradient(110deg,#00000000,45%,#ffffff50,55%,#00000000)] bg-[length:200%_100%] animate-shimmer rounded-md" />
              Get Swing Trading Kit At ₹49
            </button>
          </div>
          <div className="flex justify-center ">
            <Image
              src="/marketing/swing_trading_kit/swing_trading_kit.png"
              alt="house of traders"
              height={350}
              width={350}
              className="w-[50vw] hidden sm:inline "
            />
          </div>
        </div>
      </main>
    </>
  );
}

export default HOT;
